export async function getLiveStreamsPlaylist() {
  const gapi = (window as any).gapi;

  const response = await gapi.client.youtube.playlistItems.list({
    part: "snippet,contentDetails",
    maxResults: 50,
    playlistId: "PLU12uITxBEPHOJO1FU8qll6gQmKcXp5S7",
  });

  return response;
}
